import { DynamicFieldType } from '@page-components/shipment/common';
import { CommonUtility } from '@utility/common';
import { FormLabel } from '../Label/form-label';
import {
  InputContainer,
  InputContainerReadOnly,
  MuteLabel,
} from '../styles/common';
import { DateUtility } from '@utility/date';
import { RadioCard } from '../RadioCard';
import { RadioDropdown } from '../RadioDropdown';
import type { ShipmentDynamicFieldType } from '@hooks/shipment';

type ReadOnlyFieldProps = {
  item: ShipmentDynamicFieldType;
  layoutClass?: string | null;
  hideLabel?: boolean;
  value: any;
};

export const ReadOnlyFields = ({
  item,
  layoutClass = null,
  hideLabel,
  value,
}: ReadOnlyFieldProps) => {
  if (
    CommonUtility.isValidObject(value) &&
    ![DynamicFieldType.text, DynamicFieldType.number].includes(item.inputType)
  ) {
    return <></>;
  }

  function StyledContainer({ children }) {
    return (
      <div
        className={
          layoutClass
            ? `${layoutClass} sk:my-2!`
            : `${hideLabel ? 'sk:w-full sk:flex-none sk:px-4' : 'sk:w-3/12 sk:flex-none sk:px-4'} sk:my-2!`
        }
        key={item.name}
      >
        {children}
      </div>
    );
  }

  let toShow = value;
  if (CommonUtility.isValidArray(item.options)) {
    toShow = item.options.find(x => x.value === value)?.text || value;
  }

  switch (item.inputType) {
    case DynamicFieldType.text:
    case DynamicFieldType.number:
      return (
        <StyledContainer>
          {!hideLabel && (
            <FormLabel label={item.label} info_tooltip={item.infoTooltip} />
          )}
          <InputContainerReadOnly>
            {item.preFix && <div className="sk:mr-1!">{item.preFix}</div>}
            {CommonUtility.isValidObject(value) ? (
              <span>{value?.carrierCodeValue || ''}</span>
            ) : (
              <span>{value}</span>
            )}
          </InputContainerReadOnly>
        </StyledContainer>
      );
    case DynamicFieldType.label:
      return (
        <StyledContainer>
          {!hideLabel && (
            <FormLabel label={item.label} info_tooltip={item.infoTooltip} />
          )}
          <InputContainer>
            {item.preFix && <div className="sk:mr-1!">{item.preFix}</div>}
            <span>{value}</span>
          </InputContainer>
        </StyledContainer>
      );
    case DynamicFieldType.date:
      return (
        <StyledContainer>
          {!hideLabel && (
            <FormLabel label={item.label} info_tooltip={item.infoTooltip} />
          )}
          <InputContainer>
            <span>{DateUtility.formatDate(value)}</span>
          </InputContainer>
        </StyledContainer>
      );

    case DynamicFieldType.currency:
      return (
        <StyledContainer>
          {!hideLabel && (
            <FormLabel label={item.label} info_tooltip={item.infoTooltip} />
          )}
          <InputContainer>
            <span>{CommonUtility.currencyFormat(value)}</span>
          </InputContainer>
        </StyledContainer>
      );
    case DynamicFieldType.dropdown:
      return (
        <StyledContainer>
          {!hideLabel && (
            <FormLabel label={item.label} info_tooltip={item.infoTooltip} />
          )}
          <InputContainerReadOnly>
            <span>{toShow}</span>
          </InputContainerReadOnly>
        </StyledContainer>
      );
    case DynamicFieldType.radio:
    case DynamicFieldType.checkbox:
      return (
        <StyledContainer>
          {!hideLabel && (
            <FormLabel label={item.label} info_tooltip={item.infoTooltip} />
          )}
          <MuteLabel>{value ? 'Yes' : 'No'}</MuteLabel>
        </StyledContainer>
      );
    case DynamicFieldType.currencyLabel:
      return (
        <StyledContainer>
          {CommonUtility.currencyFormat(value, item.currency)}
        </StyledContainer>
      );
    case DynamicFieldType.radioCard:
      return <RadioCard item={item} readOnly />;
    case DynamicFieldType.radioDropdown:
      return <RadioDropdown item={item} readOnly />;
    default:
      break;
  }
};
